import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators } from '@angular/forms';
import { ValidationService } from '../../../linknet-common/validators/index';
import { WebshopService } from '../../../linknet-common/restful-services/restful.service';
import { INgxMyDpOptions } from 'ngx-mydatepicker';
import { ToastrService } from "ngx-toastr";
import { GlobalService } from 'app/linknet-common/globals/global.service';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'shop-app-employee-rr',
    templateUrl: './employee-rr.component.html',
    styleUrls: ['./employee-rr.component.scss'],
})

export class EmployeeRRComponent implements OnInit{
    public employeeRR: any;
    public optionsSelectSalutation: Array<any>;
    public loaderShow: Boolean = false;
    public myOptions: INgxMyDpOptions = {
      dateFormat: 'dd-mm-yyyy',
    };
    webshop:any;
    customerID:any;

    constructor(public datePipe: DatePipe, private formBuilder: FormBuilder, private _httpWebshopService: WebshopService, private toastr: ToastrService,public globalService: GlobalService){
      const d: Date = new Date();
      this.myOptions = {
        dateFormat: 'dd-mm-yyyy',
        disableUntil: { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() - 1 }
      }

        this.optionsSelectSalutation = [
            {
              'value': 'CAPT',
              'label': 'CAPT'
            },
            {
              'value': 'DR',
              'label': 'DR'
            },
            {
              'value': 'MR',
              'label': 'MR'
            },
            {
              'value': 'MRS',
              'label': 'MRS'
            },
            {
              'value': 'MISS',
              'label': 'MISS'
            },
            {
              'value': 'MS',
              'label': 'MS'
            }
        ];
      this.webshop = JSON.parse(sessionStorage.getItem('webshopDetail'));
      this.customerID = this.webshop.CustomerID;

    }

    loadForm(){
      const userSettings = this.globalService.getLoggedInData();
      this.employeeRR = this.formBuilder.group({
        'Salutation': [userSettings.Salutation, [Validators.required]],
        'FirstName': [userSettings.FirstName, [Validators.required]],
        'LastName': [userSettings.LastName, [Validators.required]],
        'CompanyName': [userSettings.CompanyName, [Validators.required]],
        'Email': [userSettings.Email, [Validators.required, ValidationService.emailValidator]],
        'Department': [userSettings.Department],
        'PhoneNumber': [userSettings.PhoneNumber, [Validators.required, Validators.maxLength(10)]],
        'DigitalProducts': [true],
        'PhysicalProducts': [true],
        'MerchandiseLogo': [true],
        'WhiteLabelling': [true],
        'RequiredBy': ['', [Validators.required]],
        'AnnualBudget': ['', [Validators.required]],
    });
    }

    ngOnInit() {
      this.loadForm();
    }

    onlyNumberKey(event) {
        const pattern = new RegExp('^[0-9\b]+$');
        const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
        if (!pattern.test(key) && event.charCode !== 0) {
          event.preventDefault();
          return false;
        }
    }

    proceed(){
      let board = JSON.parse(sessionStorage.getItem('billBoardList'));
      this.employeeRR.value.RequiredBy = this.datePipe.transform(this.employeeRR.value.RequiredBy.jsdate, 'dd/MM/yyyy');
      const params = {
        "Salutation": this.employeeRR.value.Salutation,
        "FirstName": this.employeeRR.value.FirstName,
        "LastName": this.employeeRR.value.LastName,
        "CompanyName": this.employeeRR.value.CompanyName,
        "Department": this.employeeRR.value.Department,
        "CompanyEmail": this.employeeRR.value.Email,
        "Mobile": this.employeeRR.value.PhoneNumber,
        "DigitalProducts": this.employeeRR.value.DigitalProducts,
        "PhysicalProducts": this.employeeRR.value.PhysicalProducts,
        "Merchandise_CompanyLogo": this.employeeRR.value.MerchandiseLogo,
        "WhiteLabelling_Program": this.employeeRR.value.WhiteLabelling,
        "RequiredBy": this.employeeRR.value.RequiredBy,
        "AnnualBudget": this.employeeRR.value.AnnualBudget,
        "BillBoardId": board[1].BillboardAdID,
        "BannerId":1,
        "CustomerId": this.customerID
      }
      this.loaderShow = true;
      this._httpWebshopService.createBanner(params).subscribe((_data)=>{
          this.loadForm();
          this.loaderShow = false;
          this.toastr.success('Enquiry submitted.')
      },_error=>{
        this.loaderShow = false;
        this.toastr.error('Please try again.')
      })
    }
}